import { ReducerFnInterface } from '@context/type';
import { JourneysWaitingConfirmDeliveryStateInterface } from './journeysWaitingConfirmDelivery.type';

export const journeysWaitingConfirmDeliveryReducer: ReducerFnInterface<
  JourneysWaitingConfirmDeliveryStateInterface
> = (state, { type, payload }) => {
  switch (type) {
    case 'journeys_waiting_confirm_delivery_loading':
      return {
        ...state,
        isFetching: true,
        isFetched: false,
        data: [],
        error: false,
      };
    case 'journeys_waiting_confirm_delivery_load_success':
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        data: payload.data,
        error: false,
      };
    case 'journeys_waiting_confirm_delivery_load_error':
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        data: [],
        error: true,
      };

    case 'journeys_waiting_confirm_delivery_remove': {
      const temJourneys = [...state.data];
      const indexElement = state.data.findIndex(
        (journey) => journey.id === payload.journeyId,
      );

      if (indexElement === -1) {
        return {
          ...state,
        };
      }

      temJourneys.splice(indexElement, 1);

      return {
        ...state,
        data: [...temJourneys],
      };
    }

    default:
      return state;
  }
};

journeysWaitingConfirmDeliveryReducer.key = 'journeysWaitingConfirmDelivery';
journeysWaitingConfirmDeliveryReducer.initialState = {
  isFetching: true,
  isFetched: false,
  data: [],
  error: false,
};
